<template>
  <svg
    data-name="app icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
    :style="`width: ${width}px; height: ${height}px;`"
  >
    <g data-name="그룹 277001" transform="translate(7 6)">
      <circle data-name="타원 9635" cx="3" cy="3" r="3" transform="translate(0 1)" :fill="fill" />
      <circle data-name="타원 9635" cx="3" cy="3" r="3" transform="translate(8 1)" :fill="fill" />
      <circle data-name="타원 9651" cx="3" cy="3" r="3" transform="translate(16 1)" :fill="fill" />
      <circle data-name="타원 9635" cx="3" cy="3" r="3" transform="translate(0 9)" :fill="fill" />
      <circle data-name="타원 9635" cx="3" cy="3" r="3" transform="translate(8 9)" :fill="fill" />
      <circle data-name="타원 9635" cx="3" cy="3" r="3" transform="translate(16 9)" :fill="fill" />
      <circle data-name="타원 9635" cx="3" cy="3" r="3" transform="translate(0 17)" :fill="fill" />
      <circle data-name="타원 9635" cx="3" cy="3" r="3" transform="translate(8 17)" :fill="fill" />
      <circle data-name="타원 9635" cx="3" cy="3" r="3" transform="translate(16 17)" :fill="fill" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SquaresIcon',
  props: {
    size: {
      type: String,
      default: 'small',
    },
  },
  computed: {
    width() {
      return this.size === 'small' ? 34 : 36;
    },
    height() {
      return this.size === 'small' ? 34 : 36;
    },
    fill() {
      return this.size === 'small' ? '#585858' : '#909090';
    },
  },
};
</script>
